import {Component} from '@angular/core';
/**
 * \@title Basic slider
 */
export class SliderOverviewExample {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'slider-overview-example',
  templateUrl: 'slider-overview-example.html',
  styleUrls: ['slider-overview-example.css'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function SliderOverviewExample_tsickle_Closure_declarations() {
/** @type {?} */
SliderOverviewExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SliderOverviewExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
